import { Typography } from '@fullstory/components';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import React, { useCallback, useMemo } from 'react';
import { useRetentionContactButton } from './useRetentionContactButton';
import { fullstorySelectors } from '@fullstory/redux';
import { useSelector } from 'react-redux';

const minPickerDate = moment().subtract(18, 'months').startOf('month').toDate();

export const useDatePickerRetentionProps = (retentionTimestamp: number | undefined) => {
  const isDayDisabled = useCallback(
    (day: Date) => !!retentionTimestamp && moment(day).isBefore(moment(retentionTimestamp), 'day'),
    [retentionTimestamp],
  );

  const createdTimestamp = useSelector(fullstorySelectors.getOrgCreatedDate);

  const minDate = useMemo(() => {
    const createdDate = moment(createdTimestamp).startOf('month');

    const retentionDate = retentionTimestamp ? new Date(retentionTimestamp) : undefined;
    const minDate = createdDate.isBefore(minPickerDate) ? createdDate.toDate() : minPickerDate;
    if (!retentionDate) return undefined;
    return retentionDate < minDate ? minDate : retentionDate;
  }, [createdTimestamp, retentionTimestamp]);

  const contactButton = useRetentionContactButton();
  const renderInfoTooltip = useCallback(
    (day: Date) => {
      if (!retentionTimestamp) return null;
      if (moment(day).isSame(retentionTimestamp, 'day')) {
        const diff = moment().diff(retentionTimestamp);
        const months = Math.round(moment.duration(diff).asMonths());
        return (
          <Typography variant="body3">
            <FormattedMessage
              defaultMessage="Your {months} month data retention period goes back to {retentionTimestamp, date, ::MMMM d}.
                              Please {contactButton} if you wish to increase your retention to analyze over longer periods of time."
              id="JNx3CE"
              values={{
                months,
                retentionTimestamp,
                contactButton,
              }}
            />
          </Typography>
        );
      }
      return null;
    },
    [retentionTimestamp, contactButton],
  );

  return {
    isDayDisabled,
    renderInfoTooltip,
    minDate,
  };
};
